require('./stylesheets/shortLinks.scss');

angular.module('pages.shortLinksService', [])
    .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider
        .state('pages.shortLinksService', {
            url: 'ls/{urlCode:[A-z0-9]{5,8}}',
            template: require('./templates/shortLinks.html'),
            controller: require('../shortLinks/controllers/shortLinks.controller'),
            data: {
                restricted: false,
                iframe: false
            },
            pageTrack: '/short-links-service'
        });
}

module.exports = 'pages.shortLinksService';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/shortLinksService/index.js
 ** module id = 295
 ** module chunks = 1
 **/